import React from 'react';
import { Container, Row } from 'reactstrap';

import DataProvider from '../services/DataProvider'

const LinksUteis=  () => {

    const [imgUtil, setImgUtil] = React.useState([])

    React.useEffect(() => {

        DataProvider.getAll('WsSanEndPoints.rule?sys=SAS').then((response) => {
            if(response.data.arquivos)
            if(typeof response.data.arquivos.filter === 'function'){
                setImgUtil(response.data.arquivos.filter((v) => v.IMG_TIPO === 'L'))
            }
            
        })

    }, []);

    return <Container className="mb-5">
        <h1 className="color-primary link-util-header-title">Links Úteis</h1>
        <Row className="px-2 text-center mb-3">
            {
    
                imgUtil.map((v,i) => {
                    return (
                        <a  href={v.IMG_LINK} className="col-md position-relative link-util" key={i} onClick={"window.open('"+v.IMG_LINK+"');"}>
                            <div className="link-util-envelope">
                                <div className="link-util-envelope-column">
                                    <a href={v.IMG_LINK} target="_blank" rel="noreferrer noopener">
                                        <img className="link-util-img" src={v.IMG_CAMINHO} alt="" style={{width:100,height:100}}/>
                                    </a>
                                </div>
                                <div className="link-util-envelope-column">
                                    <a className="link-util-title">{v.IMG_TITULO}</a><br></br>
                                    <a className="link-util-description">{v.IMG_DESCRICAO}</a>
                                </div>
                            </div>
                        </a>
                    )
                })
            }
        </Row>
    </Container>
}

export default LinksUteis;